const Loading: React.FC<{ title: string }> = ({ title }) => {
  return (
    <div style={{ fontSize: "20px", fontWeight: "bold", margin: "24px 0" }}>
      <div className="svg-loader" id="loading-heading">
        <svg className="svg-container" height="170" width="170" viewBox="0 0 100 100">
          <circle className="loader-svg bg" cx="50" cy="50" r="45"></circle>
          <circle className="loader-svg animate" cx="50" cy="50" r="45"></circle>
        </svg>
      </div>
      <div className="text-center">{title}</div>
    </div>
  );
};

export default Loading;
